import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base/base.service';

@Injectable({
    providedIn: 'root'
})
export class MercadopagoService extends BaseService {
    prefixPath = 'mercadopago';

    constructor(httpClient: HttpClient) {
      super(httpClient);
    }

    getPreferenceId(userId, planId = null, discount = 0, coupon = null): Observable<string> {
      return this.httpPost(`${this.prefixPath}/get-preference-id`, { user_id: userId, plan_id: planId, discount, coupon });
    }

    cancelPreapproval(subscription_id): Observable<any> {
      return this.httpPost(`${this.prefixPath}/cancel-preapproval`, { id: subscription_id });
    }
}